import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressTracker from '../../components/navigation/ProgressTracker';
import { useAssessment } from '../../components/navigation/AssessmentStateManager';

const PreAssessmentPreparation = () => {
  const navigate = useNavigate();
  const { setScreen } = useAssessment();

  useEffect(() => {
    setScreen('pre-assessment-preparation');
  }, [setScreen]);

  const handleReady = () => {
    navigate('/question-assessment');
  };

  return (
    <div className="min-h-screen bg-brand-black flex flex-col">
      {/* Progress Tracker */}
      <ProgressTracker />

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="max-w-2xl w-full">
          {/* Header */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-white mb-8 md:mb-10 text-center uppercase tracking-tight">
            Before You Begin
          </h1>

          {/* Body Text */}
          <div className="space-y-6 md:space-y-8 mb-10 md:mb-12">
            <p className="text-lg md:text-xl text-brand-steel leading-relaxed text-center">
              This assessment only works if you answer honestly—not how you think you should feel, but how you actually feel.
            </p>

            <p className="text-lg md:text-xl text-brand-steel leading-relaxed text-center">
              Some questions will be uncomfortable. That discomfort is data.
            </p>

            <p className="text-lg md:text-xl text-brand-steel leading-relaxed text-center">
              No one sees your answers but you. If a question stings, you're probably close to something true.
            </p>
          </div>

          {/* Ready Button */}
          <div className="flex justify-center">
            <button
              onClick={handleReady}
              className="w-full md:w-auto min-w-[280px] bg-brand-gold hover:bg-brand-gold/90 text-brand-black font-bold text-lg md:text-xl px-10 md:px-12 py-5 md:py-6 rounded-md transition-all duration-250 hover:transform hover:-translate-y-0.5 active:scale-[0.97] uppercase tracking-wide flex items-center justify-center gap-2"
            >
              I'M READY
              <span className="text-xl md:text-2xl">→</span>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PreAssessmentPreparation;